var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.349,
    height: 17.349,
    viewBox: "0 0 17.349 17.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_2",
    "data-name": "Uni\\xE3o 2",
    d: "M-489.325,10.309l-6.914,6.914-1.76-1.76,6.914-6.914L-498,1.634l1.76-1.76,6.914,6.914,6.914-6.914,1.76,1.76-6.914,6.914,6.914,6.914-1.76,1.76Z",
    transform: "translate(498 0.126)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.31d486a41f620128ff8d5e87ff559664.svg";
export { ForwardRef as ReactComponent };